export const servicePages = [
  {
    slug: "brand-website",
    seoTitle: "Website & Logo Design in Noida & Ghaziabad | Allcov",
    title: "Brand & Website",
    line: "A website that brings enquiries, not just compliments.",
    problemsTitle: "Problems We Fix",
    problems: [
      "No website, or an old one that takes forever to open on a phone.",
      "An incomplete Google listing — customers can't find your timings or call you.",
      "A developer who disappeared, with your domain still in their name.",
      "A logo that looks different on your board, your cards and your WhatsApp.",
    ],
    getTitle: "What You Get",
    getItems: [
      "A fast, mobile-first website",
      "Logo files for print and digital (SVG, PNG, PDF)",
      "Google Business Profile set up properly",
      "Domain, files and logins — all in your name",
      "A written copyright transfer",
    ],
    packagesTitle: "Packages",
    packagesNote: "+ 18% GST",
    packages: [
      {
        name: "Logo", price: "₹4,999", timeline: "5 working days",
        items: ["2 concepts, 2 revision rounds", "Logo files (SVG, PNG, PDF)", "Colour and font sheet", "WhatsApp and Google profile images", "Written copyright transfer"],
      },
      {
        name: "Brand Kit", price: "₹9,999", timeline: "10 working days",
        items: ["Logo plus business card", "Letterhead", "10 social media templates", "6-page brand guide"],
      },
      {
        name: "Launch Kit (Website)", price: "₹14,999", timeline: "10 working days", note: "First 5 clients, then ₹19,999",
        items: ["5-page mobile website", "Google Business Profile", "WhatsApp button and auto-reply", "Enquiry form to Google Sheet", "Basic local SEO", "Domain in your name"],
      },
      {
        name: "Bigger Website / E-commerce / Portal", price: "Quoted after a call", timeline: "Scoped together",
        items: ["Custom scope, fixed written quote"],
      },
      {
        name: "Care Plan", price: "₹1,999/month", timeline: "Month to month",
        items: ["Hosting, backups, updates", "1 hour of changes every month", "Monthly enquiry report"],
      },
    ],
    steps: ["Brief call", "Design", "Your approval", "Build", "Go-live & handover — domain, files, logins and copyright transfer, all in your name"],
    faq: [
      { q: "What do you need from me?", a: "Your services, prices, timings, photos and logo if you have one. We send a simple form." },
      { q: "Can you redesign my current website?", a: "Yes. We audit it first and send a fixed quote." },
      { q: "Will I be on Google's first page?", a: "We set up your Google Business Profile and local SEO properly. Nobody can honestly guarantee a ranking." },
    ],
  },
  {
    slug: "automation",
    seoTitle: "WhatsApp Business & AI Automation for Small Businesses | Allcov",
    title: "WhatsApp & AI Automation",
    line: "Your business replies in seconds — even at 2 AM.",
    problemsTitle: "Problems We Fix",
    problems: [
      "Enquiries come in at night and get a reply the next morning.",
      "Staff forget follow-ups and payment reminders.",
      "The same 10 questions get answered 50 times a day.",
      "Leads are scattered across WhatsApp, calls and notebooks.",
    ],
    getTitle: "What We Automate",
    getItems: [
      "Greeting and away messages, quick replies, catalog",
      "Booking link plus a reminder the day before",
      "Every enquiry saved to your Google Sheet or CRM within a minute",
      "Fee and payment reminders",
      "Review request after a visit",
      "A daily summary on your WhatsApp",
    ],
    packagesTitle: "Packages",
    packagesNote: "+ 18% GST",
    packages: [
      {
        name: "WhatsApp Setup", price: "₹5,000 + ₹1,500/month", timeline: "Setup in days",
        items: ["WhatsApp Business set up properly", "Auto-replies, catalog, labels, broadcast lists", "Booking link", "Monthly check-up"],
        note: "Official WhatsApp API setup is quoted separately; Meta's message charges are paid by you directly, without markup.",
      },
      {
        name: "AI Automation", price: "From ₹15,000 + ₹3,000/month", timeline: "Per workflow",
        items: ["Example: enquiry → instant WhatsApp reply → Google Sheet → follow-up reminder to your staff", "Tools: n8n, Google Sheets, WhatsApp Business and Cloud API, Zoho and KIT19 CRM"],
      },
    ],
    steps: ["Free audit call", "Map your repetitive work", "Build & test automations", "Go live", "Monthly check-up"],
    faq: [
      { q: "Will my number get blocked?", a: "We follow WhatsApp's rules: no bulk messages to people who haven't opted in." },
      { q: "Do I need new software?", a: "Usually not. Most setups run on Google Sheets and your existing WhatsApp." },
    ],
  },
  {
    slug: "sops",
    seoTitle: "SOPs, Reporting & Operations Support for SMEs | Allcov",
    title: "SOPs & Operations",
    line: "Work that runs the same way, even when you're not there.",
    problemsTitle: "Problems We Fix",
    problems: [
      "Every task depends on who is doing it that day.",
      "New staff take weeks to learn the job.",
      "No daily report, so you find problems late.",
      "You spend your day following up instead of growing.",
    ],
    getTitle: "Typical SOPs",
    getItems: [
      "Clinic front desk (appointments, reminders, billing, reviews)",
      "Coaching admissions (enquiry → counselling → fee follow-up)",
      "Sales follow-up",
      "Stock register",
      "Daily cash closing",
    ],
    packagesTitle: "Packages",
    packagesNote: "+ 18% GST",
    packages: [
      {
        name: "SOP Pack", price: "₹9,999", timeline: "One department",
        items: ["Up to 8 SOPs for one department", "Checklists", "A daily report format in Google Sheets", "1 training session for your staff"],
      },
      {
        name: "Operations Retainer", price: "₹7,999/month", timeline: "Month to month",
        items: ["Weekly review call", "Monthly report", "SOP updates and process fixes"],
      },
      {
        name: "Operations Executive", price: "From ₹20,000/month", timeline: "Dedicated",
        items: ["A trained executive for follow-ups, data entry, reports and coordination", "We hire, train, supervise and replace if needed"],
      },
    ],
    steps: ["We observe your team for 2 hours", "Draft SOPs", "Review with you", "Train the team", "Check again after 30 days"],
    faq: [
      { q: "Can SOPs be in Hindi?", a: "Yes — Hindi, English or both." },
      { q: "How do I know staff follow them?", a: "Simple checklists and a daily report you can see on your phone. The retainer adds a weekly review." },
    ],
  },
];
